import { render } from "./SettingsCardEvents.vue?vue&type=template&id=28f495a1&scoped=true"
import script from "./SettingsCardEvents.vue?vue&type=script&lang=js"
export * from "./SettingsCardEvents.vue?vue&type=script&lang=js"

import "./SettingsCardEvents.vue?vue&type=style&index=0&id=28f495a1&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f495a1"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon,QList,QSeparator,QBtn,QCheckbox,QInput});
